module.exports = __webpack_public_path__ + "static/img/2s-design-b3.cbee1de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-design-b3.jpg
// module id = AM7t
// module chunks = 0